import {
  REQUEST_SPONSOR_LIST,
  REQUEST_SPONSOR
} from './mutation-types'

import axiosInst from '@/utility/axiosInst';

export default {
  requestSponsorList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get("/admin/sponsor/sponsor-list", {
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord : searchWord
      }
    }).then((res) => {
      commit(REQUEST_SPONSOR_LIST, res.data)
    })
  },

  requestDeleteSponsors({}, payload) {
    return axiosInst.springAxiosInst.post('/admin/sponsor/delete-sponsors', payload)
    .then((res) => {
      return res.data
    })
  },

  requestSaveSponsor({}, payload) {
    return axiosInst.springAxiosInst.post("/admin/sponsor/save-sponsor", payload)
      .then((res) => {
        return res.data
      })
  },

  requestSponsor({commit}, sponsorSeq) {
    return axiosInst.springAxiosInst.get(`/admin/sponsor/sponsor/${sponsorSeq}`)
    .then((res) => {
      commit(REQUEST_SPONSOR, res.data)
    })
  },

  requestEditorImageUpload({}, payload) {
    return axiosInst.springAxiosInst.post("/file/upload-editor-img", payload)
      .then((res) => {
        return res.data
      })
  }
}